import {Default} from './variant/default';
import {Subjects} from './variant/subjects';

export const ReportSelect = Object.assign(Default, {
	Subjects,
});
